import React from "react"

import Layout from "../../components/shared/layout"
import useHeroImages from "../../components/about/useHeroImages"

import Hero from "../../components/shared/hero"
import {
  HeroOverlay,
  HeroContent,
  HeroTextContainer,
  HeroText,
  QuoteAttribution,
  Title,
} from "../../components/about/hero.style"
import HeroStatistics from "../../components/about/stats"
import Overview from "../../components/about/overview"
import LeadershipTeam from "../../components/about/leadership-team"
import CareersPromo from "../../components/about/careers-promo"
import Footer from "../../components/shared/footer"
import SEO from "../../components/shared/seo"

export default function AboutPage({ location }) {
  const images = useHeroImages()
  return (
    <Layout location={location} contactLightbox>
      <SEO
        title="About Us"
        description="Mappedin works with the largest property portfolios globally, as well as digitizing space across stores, stadiums, campuses, city districts, offices and airports."
      />
      <Hero overlayStyle={HeroOverlay} sizes={images}>
        <HeroContent>
          <Title>About Mappedin</Title>
          <HeroTextContainer>
            <HeroText>
              “I am very interested in how technology and brick-and-mortar
              collide. At Mappedin, we’re helping our clients digitize the
              indoors and maintaining a source of truth for over 500 million
              square feet of indoor maps.”
            </HeroText>
            <QuoteAttribution>
              Hongwei Liu,
              <br /> CEO of Mappedin
            </QuoteAttribution>
          </HeroTextContainer>
        </HeroContent>
      </Hero>
      <HeroStatistics />
      <Overview />
      <LeadershipTeam />
      <CareersPromo />
      <Footer />
    </Layout>
  )
}
